import type { User, UserRole } from '../api/types'

// User object-based utilities
export const isAdminUser = (user: User | null): boolean => {
  return user?.role === 'admin'
}

export const isDoctorUser = (user: User | null): boolean => {
  return user?.role === 'doctor'
}

export const isSupportUser = (user: User | null): boolean => {
  return user?.role === 'support'
}

export const isAppUser = (user: User | null): boolean => {
  return user?.role === 'user'
}

export const hasRole = (user: User | null, role: UserRole): boolean => {
  return user?.role === role
}

export const hasAnyRole = (user: User | null, roles: UserRole[]): boolean => {
  return user ? roles.includes(user.role) : false
}

// Role-based utilities (for when you already have the role)
export const isAdminRole = (role: UserRole): boolean => {
  return role === 'admin'
}

export const isDoctorRole = (role: UserRole): boolean => {
  return role === 'doctor'
}

export const isSupportRole = (role: UserRole): boolean => {
  return role === 'support'
}

export const isUserRole = (role: UserRole): boolean => {
  return role === 'user'
}

// Permission-based utilities
export const canManageUsers = (user: User | null): boolean => {
  return isAdminUser(user)
}

export const canReviewAI = (user: User | null): boolean => {
  return isAdminUser(user) || isDoctorUser(user)
}

export const canAccessSettings = (user: User | null): boolean => {
  return isAdminUser(user)
}

export const canGenerateAuthCodes = (user: User | null): boolean => {
  return isAdminUser(user) || isSupportUser(user)
}

export const canLoginAsUsers = (user: User | null): boolean => {
  return isAdminUser(user) || isSupportUser(user) || isDoctorUser(user)
}

export const canCreateOrders = (user: User | null): boolean => {
  return isAdminUser(user) || isSupportUser(user) || isDoctorUser(user)
}
